export default "__VITE_ASSET__a4vEFvOk__"